function setTitle(title) {
  document.title = title;
}

export default {
  setTitle,
};
